import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { MESSAGES } from 'src/app/core/constant/messages';
import { InputTextComponent } from 'src/app/shared/component/input-text/input-text.component';
import { LoadingButtonComponent } from 'src/app/shared/component/loading-button/loading-button.component';
import { NavButtonComponent } from 'src/app/shared/component/nav-button/nav-button.component';
import { BaseFormComponent } from 'src/app/shared/form/base-form.component';
import { AuthService } from 'src/app/shared/service/auth.service';
import { ToastService } from 'src/app/shared/service/toast.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-login-codideep',
  standalone: true,
  imports: [
    InputTextComponent,
    NavButtonComponent,
    LoadingButtonComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './login-codideep.component.html',
})
export class LoginCodideepComponent
  extends BaseFormComponent
  implements OnInit
{
  form!: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    toastService: ToastService
  ) {
    super(toastService);
  }

  ngOnInit(): void {
    this.initForm();
  }

  onSubmit(): void {
    if (!this.validateForm(this.form)) return;
    this.completeProfile();
  }

  private initForm(): void {
    this.form = this.fb.group({
      identificationDocument: [
        '',
        [Validators.required, Validators.pattern(/^\d{8}$/)],
      ],
    });
  }

  private completeProfile(): void {
    this.loading = true;

    const { identificationDocument, sex } = this.form.value;

    this.authService
      .completeRegistration({ identificationDocument, sex })
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: () => this.handleCompleteSuccess(),
        error: (err) =>
          this.showApiError(err, MESSAGES.AUTH.PROFILE_COMPLETE_ERROR),
      });
  }

  private handleCompleteSuccess(): void {
    this.toastService.showMessages('success', [
      MESSAGES.AUTH.PROFILE_COMPLETE_SUCCESS,
    ]);
    this.authService.setProfileCompleted();
    this.router.navigate(['/']);
  }
}
